import {Navigate} from 'react-router-dom';
import {useTabsConfig} from './useTabsConfig';

export const SettingsPage = () => {
  const tabs = useTabsConfig();
  const redirectPath = tabs[0].path;
  return <Navigate to={redirectPath} replace={true} />;
};
